<template>
  <div class="image-preview">
    <div class="preview-container" @click.self="closePreview">
      <div class="preview-content">
        <div class="image-wrapper">
          <img :src="currentImage" :alt="'Preview image ' + (currentIndex + 1)" />
        </div>
        
        <div class="navigation">
          <button 
            class="nav-button prev-button" 
            :disabled="currentIndex === 0"
            @click="prevImage"
          >
          <i class="el-icon-arrow-left"></i>
          </button>
          
          <span class="image-counter">
            {{ currentIndex + 1 }} / {{ images.length }}
          </span>
          
          <button 
            class="nav-button next-button" 
            :disabled="currentIndex === images.length - 1"
            @click="nextImage"
          >
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
        
        <button class="close-button" @click="closePreview">
          <i class="el-icon-close"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewImage',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: this.initialIndex,
      isOpen: true
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  methods: {
    nextImage() {
      if (this.currentIndex < this.images.length - 1) {
        this.currentIndex++;
      }
    },
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    closePreview() {
      this.currentIndex=0
      this.$emit('close');
    },
    handleKeydown(e) {
      switch (e.keyCode) {
        case 37: // 左箭头
          this.prevImage();
          break;
        case 39: // 右箭头
          this.nextImage();
          break;
        case 27: // ESC
          this.closePreview();
          break;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.prevview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.image-wrapper {
  max-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  color: white;
}

.nav-button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  padding: 20px ;
  margin: 0 10px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
  position: fixed;
  top: 50%;
}
.prev-button{
  left:20px
}
.next-button{
  right: 20px;
}
.nav-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.4);
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.image-counter {
  margin: 0 15px;
  font-size: 16px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  padding: 5px 15px;
}

.close-button:hover {
  color: #ccc;
}
</style>